<template>
  <div class="d-flex justify-content-center mt-5">
    <Camera />
  </div>
</template>

<script>
import Camera from '@/components/camera-photos.vue';
export default {
  // name: 'Camera',
  components: {
    Camera,
  },
}
</script>

<style></style>